import { bootstrapApplication } from '@angular/platform-browser';
import { applyRuntimeConfig } from './app/core/runtime-config';

// app.config.ts lee environment.ecommerceApiUrl en su nivel superior (provideStripeElements),
// no dentro de una función — un import estático se evaluaría antes de que applyRuntimeConfig()
// termine de mutar `environment`. El import() dinámico difiere esa evaluación hasta después.
applyRuntimeConfig(window.location.hostname)
  .catch(() => undefined) // fail-open: seguir con los valores por defecto del build aunque esto falle
  .then(() => Promise.all([import('./app/app.config'), import('./app/app')]))
  .then(([{ appConfig }, { App }]) => bootstrapApplication(App, appConfig))
  .catch((err) => console.error(err));
